import { NewPayerRequestMessageNotification } from 'components/notifications/NewPayerRequestMessageNotification';
import { NewPayerRequestNotification } from 'components/notifications/NewPayerRequestNotification';
import { PayerRequestAssignedNotification } from 'components/notifications/PayerRequestAssignedNotification';
import { PayerRequestStatusChangedNotification } from 'components/notifications/PayerRequestStatusChangedNotification';

export const NotificationTypes = {
    PAYREQ_APERTURE: 'PAYREQ_AP',
    PAYREQASSIGN_APERTURE: 'PR_ASS_AP',
    // Payer request status updated:
    PR_IN_PROG: 'PR_IN_PROG',
    PR_APP_REQ: 'PR_APP_REQ',
    PR_APPROVE: 'PR_APPROVE',
    PR_APP_DEN: 'PR_APP_DEN',
    PR_RESOLVE: 'PR_RESOLVE',
    PR_CLOSED: 'PR_CLOSED',
    PR_CANCEL: 'PR_CANCEL',
    // Summary emails
    PAYREQSUM_APERTURE: 'PAYREQSUMA',
    // Payer request new message
    PR_MSG_AP: 'PR_MSG_AP',
} as const;

const StatusChangeNotificationTypes = [
    NotificationTypes.PR_IN_PROG,
    NotificationTypes.PR_APP_REQ,
    NotificationTypes.PR_APPROVE,
    NotificationTypes.PR_APP_DEN,
    NotificationTypes.PR_RESOLVE,
    NotificationTypes.PR_CLOSED,
    NotificationTypes.PR_CANCEL,
];

export const NotificationComponentMap = {
    [NotificationTypes.PAYREQ_APERTURE]: NewPayerRequestNotification,
    [NotificationTypes.PAYREQASSIGN_APERTURE]: PayerRequestAssignedNotification,
    [NotificationTypes.PR_MSG_AP]: NewPayerRequestMessageNotification,
    ...Object.fromEntries(
        StatusChangeNotificationTypes.map((type) => [type, PayerRequestStatusChangedNotification]),
    ),
} as const;
